const locale = {
    placeholder: 'Válasszon időt',
    rangePlaceholder: ['Kezdési idő', 'Befejezési idő'],
};
export default locale;
